export function selectHasCartEvaluationFailed(state: App.State): boolean {
  return state.businessTraveller.cartEvaluation.status === 'failed'
}
